export const isObjectEqual = (o1, o2) => {
  if (o1 === o2) {
    return true;
  }

  if (!o1 || !o2) {
    return false;
  }

  const o1Props = Object.getOwnPropertyNames(o1);
  const o2Props = Object.getOwnPropertyNames(o2);

  if (o1Props.length !== o2Props.length) {
    return false;
  }

  for (const propName in o1) {
    if (o1[propName] !== o2[propName]) {
      return false;
    }
  }

  return true;
};

export const isObjectEmpty = (o) =>
  !o || Object.keys(o).length === 0 || Object.values(o).every((v) => v === undefined || v === null);

export const isUserEmpty = (user) =>
  isObjectEmpty(user);
